































































































































// Vue
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Mixins} from 'vue-mixin-decorator';

import Btn, {
  BtnPredefinedStyle,
  BtnColor,
  BtnWidth,
} from '@/shared/components/btn.component.vue';
import SpotlightText, {
  SpotlightTextColor,
} from '@/shared/components/SpotlightText.component.vue';

// Models
import {Client} from '@/manager/client/client.model';

// Constants
import Constants from '@/constants/constants.ts';

// Mixins
import ErrorMixin from '@/shared/mixins/error.mixin';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';

// Services
import UtilsService from '@/core/services/utils.service';

// Components
import Input, {InputType} from '@/shared/components/input.component.vue';

interface MixinInterface extends NotificationMessage, ErrorMixin {
}

@Component({
  components: {
    Btn,
    Input,
    SpotlightText,
  },
})
export default class SaleSNewUser extends Mixins<MixinInterface>(
    NotificationMessage,
    ErrorMixin,
) {
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private btnPredefinedStyle = BtnPredefinedStyle;
  private inputType = InputType;

  private client: Client = new Client();
  private nifMask = '';
  private creating = false;
  public error = {
    user: {
      firstName: '',
      lastName: '',
      email: '',
      profile: {
        phone: '',
        address: '',
        postalCode: '',
        town: '',
      },
    },
  };

  @Watch('client.user.profile.nif')
  private watchNif(newVal: string, oldVal: string) {
    if (!newVal) {
      newVal = '';
    }
    this.nifMask = UtilsService.setNifMask(newVal, this.nifMask);
  }

  private get formComplete() {
    return true;
  }

  private get disableSendFormBtn() {
    return this.creating;
  }

  private setClientFormError(err: any) {
    const serverError = err.response.data;
    this.error = {...this.error, ...serverError};
    if (err.response.status === 500) {
      this.showNotification(
          Constants.internalServerErrorMessage,
          SpotlightTextColor.Secondary,
      );
    }
  }

  private sendForm() {
    const newClient = this.client;
    (newClient as any).note = {note: ''};
    this.creating = true;
    this.$store
        .dispatch('newClient', {
          newClient,
        })
        .then((res) => {
          this.$store.dispatch('setSelectedClient', {
            id: res.user.id,
            text: res.user.fullName,
          });
          this.showNotification('Cliente creado con éxito');
          this.creating = false;
          this.cancel();
        })
        .catch((err) => {
          this.creating = false;
          this.setClientFormError(err);
        });
  }

  private cancel() {
    this.$store.dispatch('setAddingUser', false);
  }
}
